import React from 'react';
import { AwardIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const highlights = ['6 tomos organizados por progresión', '15 días de protocolo paso a paso', "50+ recetas prácticas"];
export function SystemIntro() {
  return <section className="bg-white pt-20 sm:pt-28" aria-labelledby="sistema-title" style={{
    height: "450px"
  }} data-id="element-207" data-mp="239f1vmyignrv">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-208" data-mp="2876rubflhztf">
        <Reveal data-id="element-209" data-mp="1bih8shs8f15v">
          <p className="inline-flex items-center gap-2 rounded-full bg-mint-50 px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200" data-id="element-210" data-mp="1bj0sa2xj5xm0">
            <AwardIcon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="1khunbov7qfxg" />
            El sistema más completo para el mundo hispanohablante
          </p>
          <h2 id="sistema-title" className="mt-6 font-display text-4xl leading-[1.1] text-ink sm:text-5xl" data-id="element-212" data-mp="1pj1txklmd92j">
            MegaPack Salud Plena
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-213" data-mp="30w4boizgg4oa">
            Todo listo para usar desde hoy. Sin armar nada, sin buscar más, sin adivinar qué te inflama. No es otro libro generado con IA, esto se trata de un protocolo de alguien que sabe lo que se siente!
          </p>
          <ul className="mx-auto mt-8 flex max-w-2xl flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-214" data-mp="wh63i3sv7xn8">
            {highlights.map(item => <li key={item} className="whitespace-nowrap text-sm font-medium text-mint-700" data-id="element-215" data-mp="ri2w4cpexfc3">
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}